import { computedFrom, autoinject } from 'aurelia-framework';
import { DialogController } from "aurelia-dialog";
import { WebApiService } from "../../services/web-api-service";
import { BusyService } from "../../services/busy-service";
import { SecurityService } from "../../services/security-service";
import { PageMessageService } from "../../services/page-message-service";
import { AppMessageService } from "../../services/app-message-service";
import { DivisionContact } from "../../models/division-contact";
import 'jquery';
import 'notify';
import { ContactPhone } from '../../models/contact-phone';

@autoinject
export class UpdateDivisionContactDialog {
    constructor(
        protected controller: DialogController,
        private busyService: BusyService,
        private securityService: SecurityService,
        private appMessageService: AppMessageService,
        private pageMessageService: PageMessageService,
        private api: WebApiService) {
        this.appMessageService.containerId = "update-contact-dialog";
    }

    contact: DivisionContact;
    contactPhones: Array<ContactPhone> = [];
    deletedPhones: Array<ContactPhone> = [];
    allSelected: Boolean = false;
    nameElement: HTMLElement;
    contactTypes: Array<any> = [];

    //an aray of mill codes (populated when the contact loads and bound to the mill list selection box)
    contactMills: Array<any> = [];

    async activate(model) {

        this.deletedPhones = [];

        //defaults for a new contact
        if (!model.contact) {
            this.contact = new DivisionContact();
            this.contact.divisionId = model.divisionId;
        } else {
            // get a new copy so that the original is not modified
            this.contact = await this.getDivisionContact(model.contact.id);
        }

        await this.loadContactTypes();
    }

    attached() {
        this.nameElement && this.nameElement.focus();
    }

    async loadContactTypes() {
        const result = await this.api.get("Carriers", "GetContactTypes")
        const contactTypes = JSON.parse(result.response);
        this.contactTypes = contactTypes.filter(o => o.division == true);
    }

    async getDivisionContact(contactId: number) {
        try {
            let result = await this.api.get("Divisions", "GetDivisionContact", { contactId: contactId });
            let contact = JSON.parse(result.response);
            return contact;
        } catch (e) {
            alert("Error loading contact: " + e);
        }
    }
    removePhone(phone: ContactPhone) {
        if (phone.contactPhoneId) {
            this.deletedPhones.push(phone);
        }
        let indexToRemove = this.contact.phones.findIndex(o => o == phone);
        if (indexToRemove > -1) {
            this.contact.phones.splice(indexToRemove, 1);
        }
    }
    addPhone() {
        const lastPhone = this.contact.phones[this.contact.phones.length - 1];
        if (!lastPhone || (lastPhone.type && lastPhone.number)) {
            this.contact.phones.push(new ContactPhone());
        }
    }

    delete() {
        var params = {
            id: this.contact.id
        };

        this.pageMessageService.clear();
        this.api.post("Divisions", "DeleteDivisionContact", params)
            .then(() => {
                $["notify"]("Contact deleted", { className: "success", position: "top center" });
                this.controller.ok();
            }, () => {
                this.appMessageService.addErrorMessage("Error deleting contact");
            });
    }

    save() {

        this.pageMessageService.clear();


        //save contacts immediately
        //requires a valid carrierId
        if (this.contact.divisionId == 0) {
            throw new Error("Cannot save contacts until the division has been saved.");
        }

        //ensure that contact type is selected
        if (!this.contact.contactTypeId) {
            alert("Please select a Contact Type");
            return;
        }

        //ensure that contact name is specified
        if (this.contact.contactTypeId != -100 && !this.contact.name) {
            alert("Please enter Name for the contact.");
            return;
        }

        var params = {
            contact: this.buildContactModel(),
            deletedPhones: this.deletedPhones
        };
        this.api.post("Divisions", "UpdateDivisionContact", params)
            .then(() => {
                if (!this.contact.id) {
                    this.appMessageService.addSuccessMessage("Contact created");
                } else {
                    this.appMessageService.addSuccessMessage("Contact updated");
                }
                this.controller.ok();
            }, () => {
                this.appMessageService.addErrorMessage("Error saving contact");
            });
    }

    buildContactModel() {
        return {
            id: this.contact.id,
            divisionId: this.contact.divisionId,
            name: this.contact.name,
            title: this.contact.title,
            verified: this.contact.verified,
            email: this.contact.email,
            phones: this.contact.phones,
            contactTypeId: this.contact.contactTypeId,
            city: this.contact.city,
            state: this.contact.state
        };
    }


}